import { validatePayment } from "../functions/validatePayment";

function CheckoutSuccessful(){
    const urlParams = new URLSearchParams(new URL(document.location).search);
    const paymentId = urlParams.get('paymentId');
    validatePayment(paymentId);
    window.location.href = '/feed';
    return <>
    </>
}
    
export default CheckoutSuccessful;